import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterObjects',
    standalone: true,
    // pure: false
})
export class FilterObjectsPipe implements PipeTransform {
    transform(items: any[], filter: { [ key: string ]: any }, strict: boolean = true): any[] {
        console.log(items);
        // console.log(filter);
        // console.log(strict)
        if (!items || !filter) {
            return items;
        }

        return items.filter(item => {
            return Object.keys(filter).every(key => {
                if (strict) {
                    return item[ key ] === filter[ key ];
                } else {
                    // For non-strict comparison, you can use loose equality (==) instead
                    return item[ key ] == filter[ key ];
                }
            });
        });
    }
}
